module.exports = __webpack_public_path__ + "img/icon-table.5f24cb60.svg";